import React from 'react';

export const CompareSpecs = () => {
  return (
    <section className="fpv-pilot-compare-section">
      <div className="fpv-pilot-compare-content">
        <div className="fpv-pilot-compare-titles">
          <h3 className="fpv-pilot-compare-subtitle">
            Technical specifications
          </h3>
          <h2 className="fpv-pilot-compare-title">compare the specs</h2>
        </div>
        <div className="fpv-pilot-compare-specs-layout">
          <div className="fpv-pilot-compare-specs">
            <div className="fpv-pilot-compare-spec">
              <h3 className="fpv-pilot-compare-spec-title">Viewing angle</h3>
              <p className="fpv-pilot-compare-spec-description">37°</p>
            </div>
            <div className="fpv-pilot-compare-spec">
              <h3 className="fpv-pilot-compare-spec-title">
                Screen resolution
              </h3>
              <p className="fpv-pilot-compare-spec-description">
                1280 x 960 pixels
              </p>
            </div>
            <div className="fpv-pilot-compare-spec">
              <h3 className="fpv-pilot-compare-spec-title">Aspect ratio</h3>
              <p className="fpv-pilot-compare-spec-description">
                4:3 Native or 16:9 (720p)
              </p>
            </div>
            <div className="fpv-pilot-compare-spec">
              <h3 className="fpv-pilot-compare-spec-title">Power supply</h3>
              <p className="fpv-pilot-compare-spec-description">
                6-26VDC (2-6S Li-ion Battery)
              </p>
            </div>
          </div>

          <div className="fpv-pilot-compare-specs">
            <div className="fpv-pilot-compare-spec">
              <h3 className="fpv-pilot-compare-spec-title">
                Power consumption
              </h3>
              <p className="fpv-pilot-compare-spec-description">
                2.6W, typical
              </p>
            </div>
            <div className="fpv-pilot-compare-spec">
              <h3 className="fpv-pilot-compare-spec-title">
                Integrated Head Tracker output
              </h3>
              <p className="fpv-pilot-compare-spec-description">3.5mm jack</p>
            </div>
            <div className="fpv-pilot-compare-spec">
              <h3 className="fpv-pilot-compare-spec-title">HDMI video input</h3>
              <p className="fpv-pilot-compare-spec-description">micro HDMI</p>
            </div>
            <div className="fpv-pilot-compare-spec">
              <h3 className="fpv-pilot-compare-spec-title">
                Battery connector
              </h3>
              <p className="fpv-pilot-compare-spec-description">
                2.1 x 5.5mm barrel connector
              </p>
            </div>
          </div>

          <div className="fpv-pilot-compare-specs">
            <div className="fpv-pilot-compare-spec">
              <h3 className="fpv-pilot-compare-spec-title">IPD range</h3>
              <p className="fpv-pilot-compare-spec-description">56-74 mm</p>
            </div>
            <div className="fpv-pilot-compare-spec">
              <h3 className="fpv-pilot-compare-spec-title">Focus adjust</h3>
              <p className="fpv-pilot-compare-spec-description">-4D - +4D</p>
            </div>
            <div className="fpv-pilot-compare-spec">
              <h3 className="fpv-pilot-compare-spec-title">Integrated DVR</h3>
              <p className="fpv-pilot-compare-spec-description">
                1280x960, 50/60fps, H.264, mp4
              </p>
            </div>
            <div className="fpv-pilot-compare-spec">
              <h3 className="fpv-pilot-compare-spec-title">
                Standard receiver bay
              </h3>
              <p className="fpv-pilot-compare-spec-description">
                5V, High power
              </p>
            </div>
          </div>

          <div className="fpv-pilot-compare-specs">
            <div className="fpv-pilot-compare-spec">
              <h3 className="fpv-pilot-compare-spec-title">
                Secondary bay for additional modules
              </h3>
              <p className="fpv-pilot-compare-spec-description">
                5V, SDIO, Uart
              </p>
            </div>
            <div className="fpv-pilot-compare-spec">
              <h3 className="fpv-pilot-compare-spec-title">Weight</h3>
              <p className="fpv-pilot-compare-spec-description">256g</p>
            </div>
            <div className="fpv-pilot-compare-spec">
              <h3 className="fpv-pilot-compare-spec-title">Dimensions</h3>
              <p className="fpv-pilot-compare-spec-description">
                177 x 107 x 72mm
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
